module.exports = __webpack_public_path__ + "media/images/emblems/Duillier-coat_of_arms-ff16badf727c70afb328dcb6ea5abcff.svg";